import { render, staticRenderFns } from "./ForgotPasswordRequest.vue?vue&type=template&id=0509a262&"
import script from "./ForgotPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports